import React, { Component } from 'react';
import { Redirect, Route, Switch } from 'react-router-dom';
import FollowUpsHome from './home/FollowUpsHome';
import FollowUpsHistory from './history/FollowUpsHistory';

class FollowUps extends Component {
  render() {
    const { match } = this.props;

    return (
      <Switch>
        <Route exact path={`${match.path}/`} component={FollowUpsHome} />
        <Route exact path={`${match.path}/history`} component={FollowUpsHistory} />
        <Redirect to={match.path} />
      </Switch>
    );
  }
}

export default FollowUps;



// WEBPACK FOOTER //
// ./src/follow-ups/FollowUps.js